import {makeActionCreator} from '../utility'

export const SUBMIT_PAYMENT = 'SUBMIT_PAYMENT'
export const submitPayment = makeActionCreator(SUBMIT_PAYMENT,'data')

export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED'
export const paymentReceived = makeActionCreator(PAYMENT_RECEIVED, 'data')

export const CLEAR_PAYMENT_LOADER = 'CLEAR_PAYMENT_LOADER'
export const clearPaymentLoader = makeActionCreator(CLEAR_PAYMENT_LOADER, 'data')


export const CHECK_PAYMENT_STATUS = 'CHECK_PAYMENT_STATUS'
export const checkPaymentStatus = makeActionCreator(CHECK_PAYMENT_STATUS, 'data')


export const PAYMENT_STATUS_RECEIVED = 'PAYMENT_STATUS_RECEIVED'
export const paymentStatusReceived = makeActionCreator(PAYMENT_STATUS_RECEIVED, 'data')


export const GENERATE_BILL_ID = 'GENERATE_BILL_ID'
export const generateBillId = makeActionCreator(GENERATE_BILL_ID, 'data')


export const GENERATE_BILL_ID_RECEIVED = 'GENERATE_BILL_ID_RECEIVED'
export const generateBillIdReceived = makeActionCreator(GENERATE_BILL_ID_RECEIVED, 'data')


export const CLEAR_PAYMENTS = 'CLEAR_PAYMENTS'
export const clearPayments = makeActionCreator(CLEAR_PAYMENTS, 'data')

